


















import Vue from 'vue'
import Block from '@/components/Block.vue'

export default Vue.extend({
  name: 'RequestAccountDeleteDialog',
  components: {
    Block,
  },
  props: {
    value: {
      type: Boolean,
    },
  },
  data: () => ({}),
})
